/* ==========================================================================
   Äylor — Shop All / collection page behaviour (HYA, 2 Sep 2026)
   - Quick Add: the + button opens a size row on the card; picking a size adds
     to the bag and opens the theme's cart drawer (no PDP visit needed)
   - Colour swatches: hover previews the sibling colourway's image, click goes to it
   - Sort menu + Filter drawer: update the grid in place (section rendering API),
     keep the URL in sync so results are shareable / back-button friendly
   Everything is delegated from document so it survives grid re-renders.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__aylorCollectionInit) return;
  window.__aylorCollectionInit = true;

  var ROOT_SEL = '[data-aylor-collection]';
  var pending = null;

  /* ----------------------------------------------------------------------
     Helpers
     ---------------------------------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function sectionId() { var r = qs(ROOT_SEL); return r ? r.getAttribute('data-section-id') : null; }

  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function cartSections() {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(variantId) {
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (res) { return res.json(); }).then(function (state) {
      if (state.status && state.status >= 400) {
        var err = new Error(state.description || state.message || 'Could not add to bag');
        err.cart = state;
        throw err;
      }
      return state;
    });
  }

  function showCart(state) {
    var drawer = cartDrawer();
    if (drawer && state && state.sections && typeof drawer.renderContents === 'function') {
      try { drawer.renderContents(state); return; } catch (e) { /* fall through */ }
    }
    // No drawer on this page: refresh the header count and keep the shopper where they are.
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      qsa('.cart-count-bubble').forEach(function (b) {
        var v = b.querySelector('[aria-hidden="true"]');
        if (v) v.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function () {});
  }

  /* ----------------------------------------------------------------------
     Quick add
     ---------------------------------------------------------------------- */
  function closeAllPanels(except) {
    qsa('[data-quick-add-panel]').forEach(function (panel) {
      if (panel === except) return;
      hidePanel(panel);
    });
  }

  function hidePanel(panel) {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-visible');
    var card = panel.closest('[data-aylor-card]');
    var toggle = card && card.querySelector('[data-quick-add-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (card) card.classList.remove('is-open');
    window.setTimeout(function () { panel.hidden = true; }, 180);
  }

  function showPanel(panel) {
    closeAllPanels(panel);
    var card = panel.closest('[data-aylor-card]');
    var toggle = card && card.querySelector('[data-quick-add-toggle]');
    panel.hidden = false;
    window.requestAnimationFrame(function () { panel.classList.add('is-visible'); });
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (card) card.classList.add('is-open');
    var first = panel.querySelector('[data-quick-add-variant]:not([disabled])');
    if (first && window.matchMedia('(hover: hover)').matches) first.focus({ preventScroll: true });
  }

  function flashAdded(card) {
    var btn = card.querySelector('.aylor-quick-add');
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    window.setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
  }

  function handleAdd(card, variantId, trigger) {
    var btn = card.querySelector('.aylor-quick-add');
    var error = card.querySelector('[data-quick-add-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (btn) btn.classList.add('is-loading');
    if (trigger) trigger.classList.add('is-loading');

    addToCart(variantId).then(function (state) {
      var panel = card.querySelector('[data-quick-add-panel]');
      if (panel) hidePanel(panel);
      flashAdded(card);
      showCart(state);
      document.dispatchEvent(new CustomEvent('aylor:added', { detail: { variantId: variantId, card: card } }));
    }).catch(function (err) {
      if (btn) btn.classList.remove('is-loading');
      if (error) { error.textContent = (err && err.message) || 'Could not add to bag'; error.hidden = false; }
    }).then(function () {
      if (trigger) trigger.classList.remove('is-loading');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault(); e.stopPropagation();
      var card = toggle.closest('[data-aylor-card]');
      var panel = card && card.querySelector('[data-quick-add-panel]');
      if (!panel) return;
      if (panel.hidden) showPanel(panel); else hidePanel(panel);
      return;
    }

    var close = e.target.closest('[data-quick-add-close]');
    if (close) {
      e.preventDefault(); e.stopPropagation();
      var p = close.closest('[data-quick-add-panel]');
      hidePanel(p);
      var c = p && p.closest('[data-aylor-card]');
      var t = c && c.querySelector('[data-quick-add-toggle]');
      if (t) t.focus({ preventScroll: true });
      return;
    }

    var direct = e.target.closest('[data-quick-add-direct]');
    if (direct) {
      e.preventDefault(); e.stopPropagation();
      handleAdd(direct.closest('[data-aylor-card]'), direct.getAttribute('data-quick-add-variant'), null);
      return;
    }

    var size = e.target.closest('.aylor-size[data-quick-add-variant]');
    if (size) {
      e.preventDefault(); e.stopPropagation();
      if (size.disabled || size.classList.contains('is-loading')) return;
      handleAdd(size.closest('[data-aylor-card]'), size.getAttribute('data-quick-add-variant'), size);
      return;
    }

    // Click anywhere else closes open size rows
    if (!e.target.closest('[data-quick-add-panel]')) closeAllPanels(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = qs('[data-quick-add-panel]:not([hidden])');
      if (open) {
        var card = open.closest('[data-aylor-card]');
        hidePanel(open);
        var t = card && card.querySelector('[data-quick-add-toggle]');
        if (t) t.focus({ preventScroll: true });
      }
      closeSort();
      closeDrawer();
    }
  });

  /* ----------------------------------------------------------------------
     Swatch preview (hover shows the sibling colourway on this card)
     ---------------------------------------------------------------------- */
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('[data-swatch-link]');
    if (!sw || !window.matchMedia('(hover: hover)').matches) return;
    var card = sw.closest('[data-aylor-card]');
    var img = card && card.querySelector('.aylor-card__img--primary');
    var src = sw.getAttribute('data-image');
    if (!card || !img || !src) return;
    if (!img.dataset.aylorSrc) { img.dataset.aylorSrc = img.getAttribute('src'); img.dataset.aylorSrcset = img.getAttribute('srcset') || ''; }
    img.setAttribute('src', src);
    img.setAttribute('srcset', sw.getAttribute('data-image-srcset') || '');
    card.classList.add('is-previewing');
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('[data-swatch-link]');
    if (!sw) return;
    var card = sw.closest('[data-aylor-card]');
    var img = card && card.querySelector('.aylor-card__img--primary');
    if (!card || !img || !img.dataset.aylorSrc) return;
    img.setAttribute('src', img.dataset.aylorSrc);
    img.setAttribute('srcset', img.dataset.aylorSrcset || '');
    card.classList.remove('is-previewing');
  });

  /* ----------------------------------------------------------------------
     Sort menu
     ---------------------------------------------------------------------- */
  function closeSort() {
    qsa('[data-aylor-sort]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-sort-toggle]');
      var menu = wrap.querySelector('.aylor-sort__menu');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sort-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('[data-aylor-sort]');
      var menu = wrap.querySelector('.aylor-sort__menu');
      var open = toggle.getAttribute('aria-expanded') === 'true';
      closeSort();
      if (!open) { menu.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
      return;
    }
    var option = e.target.closest('[data-sort-value]');
    if (option) {
      e.preventDefault();
      var value = option.getAttribute('data-sort-value');
      closeSort();
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      var sortInput = qs('[data-sort-input]');
      if (sortInput) sortInput.value = value;
      render(url.toString(), true);
      return;
    }
    if (!e.target.closest('[data-aylor-sort]')) closeSort();
  });

  /* ----------------------------------------------------------------------
     Filter drawer
     ---------------------------------------------------------------------- */
  var lastFocus = null;

  function drawer() { return qs('[data-aylor-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    qsa('[data-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var closeBtn = d.querySelector('.aylor-drawer__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    qsa('[data-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-filter-close]')) { e.preventDefault(); closeDrawer(); return; }

    var link = e.target.closest('[data-facet-link]');
    if (link) {
      e.preventDefault();
      var href = link.getAttribute('href');
      var url = new URL(href, window.location.origin);
      var sortInput = qs('[data-sort-input]');
      if (sortInput && sortInput.value && !url.searchParams.has('sort_by')) url.searchParams.set('sort_by', sortInput.value);
      render(url.toString(), true);
    }
  });

  var priceTimer = null;
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-aylor-facets-form]');
    if (!form) return;
    if (e.target.type === 'number') {
      window.clearTimeout(priceTimer);
      priceTimer = window.setTimeout(function () { submitForm(form); }, 500);
      return;
    }
    submitForm(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-aylor-facets-form]');
    if (!form) return;
    e.preventDefault();
    submitForm(form);
  });

  function submitForm(form) {
    var params = new URLSearchParams(new FormData(form));
    // Drop empty price fields so they don't count as filters
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    var base = form.getAttribute('action') || window.location.pathname;
    var url = new URL(base, window.location.origin);
    url.search = params.toString();
    render(url.toString(), true);
  }

  /* ----------------------------------------------------------------------
     Render (section rendering API) — swaps grid, count, chips and drawer form
     ---------------------------------------------------------------------- */
  function render(url, push) {
    var id = sectionId();
    var root = qs(ROOT_SEL);
    if (!id || !root) { window.location.href = url; return; }
    var grid = qs('[data-aylor-grid]', root);
    if (grid) grid.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', id);
    var token = {};
    pending = token;

    fetch(fetchUrl.toString()).then(function (r) { return r.text(); }).then(function (html) {
      if (pending !== token) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newRoot = doc.querySelector(ROOT_SEL);
      if (!newRoot) { window.location.href = url; return; }

      swap('[data-aylor-grid]', root, newRoot);
      swap('#AylorCount-' + id, root, newRoot);
      swap('[data-aylor-active]', root, newRoot, true);
      swap('[data-aylor-facets-form]', root, newRoot);
      swap('[data-aylor-toolbar]', root, newRoot);

      var newResults = newRoot.querySelector('[data-filter-results]');
      var results = root.querySelector('[data-filter-results]');
      if (newResults && results) results.parentNode.innerHTML = newResults.parentNode.innerHTML;

      if (push) window.history.pushState({ aylor: url }, '', url);
      if (typeof window.loadMore === 'function') { try { window.loadMore(); } catch (e) { /* noop */ } }
      document.dispatchEvent(new CustomEvent('aylor:rendered', { detail: { url: url } }));

      var top = root.getBoundingClientRect().top + window.pageYOffset - 120;
      var toolbar = root.querySelector('[data-aylor-toolbar]');
      if (toolbar) top = toolbar.getBoundingClientRect().top + window.pageYOffset - 120;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }).catch(function () {
      window.location.href = url;
    }).then(function () {
      if (pending !== token) return;
      var g = qs('[data-aylor-grid]', root);
      if (g) g.classList.remove('is-loading');
      root.removeAttribute('aria-busy');
    });
  }

  function swap(sel, root, newRoot, replaceNode) {
    var cur = root.querySelector(sel);
    var next = newRoot.querySelector(sel);
    if (!cur) return;
    if (!next) { if (replaceNode) cur.hidden = true; return; }
    if (replaceNode) { cur.replaceWith(next); return; }
    cur.innerHTML = next.innerHTML;
    Array.prototype.forEach.call(next.attributes, function (a) { if (a.name !== 'id') cur.setAttribute(a.name, a.value); });
    if (next.hidden) cur.hidden = true; else cur.hidden = false;
  }

  window.addEventListener('popstate', function () {
    if (qs(ROOT_SEL)) render(window.location.href, false);
  });

  /* ----------------------------------------------------------------------
     Theme editor: re-run nothing special, delegation covers it
     ---------------------------------------------------------------------- */
})();
